// extracted by mini-css-extract-plugin
export default {"table":"_44WIQfjnItoOOJDI2gUy","loadMore":"_3234uMLoBeUfQCzYqWAfIW","tableContainer":"FEhgk4ll_jUPA-s43BmET","ellipsisBlock":"_1k4AJH-qw6IkUkwDnrvh1G"};